import i18next from 'i18next';

import alerts from 'common/modules/alerts';

import deleteProposal from './deleteProposal';

export default (filterData, proposalId, proposalName, value) => (dispatch) => {
    const dataAlert = {
        confirmText: i18next.t('Delete'),
        messages: [
            i18next.t('Are you sure to remove the item "{{name}}"?', {
                name: proposalName,
            }),
        ],
        onSuccess: () =>
            dispatch(deleteProposal(filterData, proposalId, value)),
        title: i18next.t('Confirmation'),
        type: alerts.ALERT_TYPE_CONFIRM,
        variant: 'warning',
    };

    dispatch(alerts.actions.show(dataAlert));
};
